import { render, staticRenderFns } from "./donate.vue?vue&type=template&id=072ab2eb&scoped=true&"
import script from "./donate.vue?vue&type=script&lang=js&"
export * from "./donate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072ab2eb",
  null
  
)

export default component.exports